
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FormItemProps } from ".";
import { loading, find } from "store/form";

interface ApiFormFindByIdInputProps {
    id: number;
    fields?: string;
}

type ApiFormFindOutputProps = OutputBaseProps<{ item: FormItemProps; }, ApiFormFindByIdInputProps>

export const apiFormFindById = async ({ id, ...data }: ApiFormFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFormFindOutputProps>(`/api/form/${id}`, { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiFormFindByCodeInputProps {
    code: string;
}

export const apiFormFindByCode = async ({ code, ...data }: ApiFormFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFormFindOutputProps>(`/api/form/code/${code}`, { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};